import _ from 'lodash';
import React from 'react';
import BooleanFilter from '../components/BooleanFilter';
import DateFilter from '../components/DateFilter';
import NumberFilter from '../components/NumberFilter';
import SelectFilter from '../components/SelectFilter';
import TextFilter from '../components/TextFilter';
import booleanFilterMethod from '../filter-methods/booleanFilterMethod';
import dateFilterMethod from '../filter-methods/dateFilterMethod';
import numberFilterMethod from '../filter-methods/numberFilterMethod';
import textFilterMethod from '../filter-methods/textFilterMethod';

function applyTextFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <TextFilter {...props} data={data} />,
    filterMethod: textFilterMethod,
  };
}

function applyMultilineTextFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <TextFilter {...props} data={data} />,
    filterMethod: textFilterMethod,
  };
}

function applyBooleanFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <BooleanFilter {...props} data={data} />,
    filterMethod: booleanFilterMethod,
  };
}

function applySelectFilter(column, options) {
  return {
    ...column,
    filterable: true,
    filterMethod: (filter, row) => {
      if (filter.value === 'all') {
        return true;
      }
      return row[filter.id] === filter.value;
    },
    Filter: SelectFilter(options),
  };
}

function applyNumberFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <NumberFilter {...props} data={data} key={column.Header} />,
    filterMethod: numberFilterMethod,
    type: 'number',
  };
}

function applyFloatFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <NumberFilter {...props} data={data} key={column.Header} />,
    filterMethod: numberFilterMethod,
    type: 'float',
  };
}

function applyDateFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <DateFilter {...props} data={data} />,
    filterMethod: dateFilterMethod,
    type: 'date',
  };
}

function applyDateWithDayNameFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <DateFilter {...props} data={data} />,
    filterMethod: dateFilterMethod,
    type: 'dateWithDayName',
  };
}

function applyDatetimeFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <DateFilter {...props} data={data} />,
    filterMethod: dateFilterMethod,
    type: 'dateTime',
  };
}

export default function fieldFilters(data) {
  return {
    applyNumberFilter: _.bind(applyNumberFilter, null, _, data),
    applyFloatFilter: _.bind(applyFloatFilter, null, _, data),
    applyTextFilter: _.bind(applyTextFilter, null, _, data),
    applyMultilineTextFilter: _.bind(applyMultilineTextFilter, null, _, data),
    applyDateFilter: _.bind(applyDateFilter, null, _, data),
    applyDateWithDayNameFilter: _.bind(applyDateWithDayNameFilter, null, _, data),
    applyDatetimeFilter: _.bind(applyDatetimeFilter, null, _, data),
    applyBooleanFilter: _.bind(applyBooleanFilter, null, _, data),
    applySelectFilter,
  };
}
